import { Stack } from '@mui/material';
import { GridPagination } from '@mui/x-data-grid';
import { Show } from '@side/pantry';
import type { ComponentProps } from 'react';
import { FilterValuesFooter } from '../FilterValuesFooter/FilterValuesFooter';

interface Props {
  hidePaginationControls?: boolean;
  variant: ComponentProps<typeof FilterValuesFooter>['variant'];
}

export function TablePagination({ hidePaginationControls, variant }: Props) {
  return (
    <Stack
      sx={{
        width: '100%',
        gap: { xs: 0, md: 2 },
        alignItems: { xs: 'flex-end', md: 'flex-start' },
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Show when={!hidePaginationControls}>
        <GridPagination />
      </Show>
      <FilterValuesFooter
        variant={variant}
        sx={{
          ml: { xs: 0, md: 'auto' },
          pt: { xs: 0, md: hidePaginationControls ? 0 : 2 },
        }}
      />
    </Stack>
  );
}
